import React from 'react'
import { Table } from '../../../components'
import { lapColumns as columns } from '../../../utils/constants'
const LapsIntervals = ({ workoutInterval }) => (
  <Table title="Laps/Intervals:" columns={columns} rows={workoutInterval} />
)

export default LapsIntervals
